import type { SearchDestination } from '@@/types/types'

export const getTrackViewPageType = (pageData?: Partial<SearchDestination>) => {
  if (!pageData?.destination) return 'other'
  switch (true) {
    case pageData.isSeoFacet:
      return 'search_filtered'
    case pageData.isLpInspi:
      return 'landing_destination_inspiration'
    case pageData.destination.isCountry:
      return 'landing_destination_country'
    case pageData.destination.isCluster:
      return 'landing_destination_cluster'
    default:
      return 'landing_destination_destination'
  }
}

export const buildTrackEventProduct = ({
  houseId,
  houseName,
  iconic,
  onlineBookingAvailable,
  price,
}: {
  houseId: string
  houseName: string
  iconic: boolean
  onlineBookingAvailable: boolean
  price?: number
}) => ({
  house_id: houseId,
  house_name: houseName,
  iconic,
  online_booking_available: onlineBookingAvailable,
  price,
})
